import { useContext } from 'react';
import { AppContext } from 'new/contexts/AppContext';

export function useAppContext() {
  return useContext(AppContext);
}
